import ajax from '../utils/ajax';

export const changesData = {
  get: id => ajax.get(`/api/changes/${id}/`),
  post: payload => ajax.post('/api/changes/', payload)
};
